export default __webpack_public_path__ + "static/media/admatic-logo-updated.f023dc1b.png";